module.exports = __webpack_public_path__ + "img/f4-01.d4ca46a7.png";